<template>
  <div class="adhocEmailContent">
    <div class="d-flex">
      <SlotWrapper>
        <template #trigger>
          <ToggleSwitch
            v-model="editMode"
            class="ml-auto mb-2"
            label-off="Edit Mode"
          />
        </template>
      </SlotWrapper>
    </div>
    <div class="inlinePreviewContainer">
      <EmailTemplatePreviewInline
        v-show="editMode"
        ref="emailPreviewInlineEl"
        class="inlinePreview"
      />
      <EmailTemplatePreview v-show="!editMode" class="inlinePreview" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

import SlotWrapper from "@/components/SlotWrapper";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import EmailTemplatePreview from "@/EmailTemplates/EmailTemplatePreview.vue";
import EmailTemplatePreviewInline from "@/EmailTemplates/EmailTemplatePreviewInline.vue";
import { injectUseEmailTemplates } from "@/EmailTemplates/useEmailTemplates";
import { injectUseEmailQuoteOrInvoice } from "./useEmailQuoteOrInvoice";

const { quote, invoice } = injectUseEmailQuoteOrInvoice();
const emailPreviewInlineEl = ref<any>();
const { selectedTemplateKey } = injectUseEmailTemplates();
const editMode = ref(false);

watch(editMode, (val) => {
  if (val) {
    setTimeout(() => {
      emailPreviewInlineEl.value.resizeIframes();
    }, 10);
  }
});

watch(
  () => `Q:${quote.value?.id}, I:${invoice.value?.invoice_id}`,
  () => {
    if (quote.value) {
      selectedTemplateKey.value = "quote_details";
    } else {
      selectedTemplateKey.value = "invoice_details";
    }
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
.inlinePreviewContainer {
  background: white;
  border: 1px solid var(--gray-border-color);
}
.inlinePreview {
  width: 100%;
  height: calc(100vh - 240px);
}
</style>
